import useSWR from 'swr';
import { PassService } from '../../api/services/PassService';
import type { PassLookupResponse } from '../../api/models/PassLookupResponse';

const fetchCustomerPasses = async ([, orderNumber, email]: [string, number, string]) => {
  return PassService.customerPassLookup({ pass_order_number: orderNumber, email });
};

export const usePassDashboardData = (orderNumber: number | null, email: string | null) => {
  const { data, error, isLoading, mutate } = useSWR<PassLookupResponse>(
    orderNumber && email ? ['customer-passes', orderNumber, email] : null,
    fetchCustomerPasses,
    {
      refreshInterval: 30000,
      revalidateOnFocus: true,
    },
  );

  return {
    passes: data?.passes || [],
    orders: data?.orders || [],
    account: data?.account,
    employeeIdToName: data?.employee_id_to_name || {},
    isLoading,
    isError: !!error,
    error,
    mutate,
  };
};
